import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { TriangleAlert } from 'lucide-react';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div className="flex min-h-screen items-center justify-center bg-background px-4">
        <Card className="w-full max-w-md border-dashed">
          <CardContent className="flex flex-col items-center justify-center py-12 text-center">
            <div className="mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-muted">
              <TriangleAlert className="h-6 w-6 text-muted-foreground" />
            </div>
            <div className="text-base font-semibold">Something went wrong</div>
            <div className="mt-1 max-w-md text-sm text-muted-foreground">
              This page hit an unexpected error. Reloading usually fixes it.
            </div>
            <div className="mt-4 flex gap-2">
              <Button variant="outline" onClick={() => this.setState({ hasError: false })}>Try again</Button>
              <Button onClick={() => window.location.reload()}>Reload page</Button>
            </div>
          </CardContent>
        </Card>
      </div>
    );
  }
}
